import { selectCountDownStartTimeArray, setCountDownStartTimeArray, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

export const useCountDownTimer = (duration: number, id: string) => {
	const dispatch = useAppDispatch();

	const countDownStartTimeArray = useAppSelector(selectCountDownStartTimeArray);

	const countDownStartTime = countDownStartTimeArray.find((i) => i.id === id);

	const startCountDownTimer = useCallback(() => {
		const isExisting = countDownStartTimeArray.some((i) => i.id === id);
		const startTime = Date.now() + duration * 1000;

		const updatedArray = isExisting
			? countDownStartTimeArray.map((i) => (i.id === id ? { ...i, startTime } : i))
			: [...countDownStartTimeArray, { id, startTime }];

		dispatch(setCountDownStartTimeArray(updatedArray));
	}, [countDownStartTimeArray, dispatch, duration, id]);

	return {
		startCountDownTimer,
		isCountDownActive: !!countDownStartTime?.startTime,
	};
};
